import { SAVE_SYSLOG } from './constants';

export function saveSyslog({ values, returnUrl }) {
  return {
    type: SAVE_SYSLOG,
    payload: {
      trigger: values.get('trigger'),
      triggerTime: values.get('triggerTime'),
      cron: values.get('cron'),
      returnUrl,
    },
  };
}
